import { Navigation } from "./Navigation";

import { AppSidebar } from "./AppSidebar";
import { SidebarProvider } from "../ui/sidebar";

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="antialiased">
      <SidebarProvider>
        <div className="flex h-screen w-full max-w-[1800px] mx-auto">
          <AppSidebar />
          <main className="flex-1 p-2 space-y-4">
            <Navigation />
            <div>{children}</div>
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
};
